import React from 'react';
import Input from 'blocks/Input';
import _ from 'lodash';
import HttpClient from 'services/HttpClient';
import {inject} from 'mobx-react';

const CHECK_COUPON = '/api/v1/coupons/?code=';

@inject('alert')
@inject('workshopDetails')
export default class EnterCouponCode extends React.Component {

  state = {showInput: false, coupon: '', errors: ''};

  handleChange = e => {
    let newState = _.assign({}, this.state, e);
    this.setState(newState);
  };

  showInput = e => {
    e.preventDefault();
    this.setState({showInput: true})
  };

  handleSubmit = e => {
    e.preventDefault();
    new HttpClient().get(CHECK_COUPON + this.state.coupon + `&workshop_id=${this.props.workshopDetails.workshop.id}`).then(data => {
      this.props.alert.error('Code successfully accepted');
      this.props.workshopDetails.updateCost(data.body.coupon.cost, this.state.coupon);
      localStorage.setItem('@coupon', this.state.coupon);
      this.setState({coupon: '',showInput: false});
    }).catch(e => {
      this.setState({coupon: ''});
      if(e.status === 404)
        this.props.alert.error('Invalid code entered, please try again');
      if(e.status === 400)
        this.props.alert.error('The code you entered has expired and is no longer valid');

    })
  };

  render(){
    return <div className="enter-coupon" style={{textAlign: 'center', marginBottom: 8}}>
      {!this.state.showInput ? <a href="#" onClick={this.showInput}
                                  style={{fontSize: 15}}>Discount code</a> :
        <div className="row">
          <form onSubmit={this.handleSubmit}>
          <div className="col-7">
            <Input name="coupon"
                   type="text"
                   grey={true}
                   value={this.state.coupon}
                   handleChange={this.handleChange}
                   placeholder="Enter Code"
                   error={this.state.errors}/>
          </div>
          <div className="col-3 validate-wrap">
            <span className="btn prime bordered validate-button" onClick={this.handleSubmit}>
              Apply Code
            </span>
          </div>
          </form>
        </div>
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/EnterCouponCode.jsx